/**
 * Playlist identifiers.
 *
 * Two shapes are accepted in the URL (/:playlistID):
 *   - share IDs: the 7 characters nanoid generates on the backend (A-Za-z0-9_-),
 *     e.g. "CAE3d6V". "default" — the public, logged-out playlist — is one too;
 *   - vanity aliases: 2–32 characters of letters, digits and a few URL-safe symbols,
 *     e.g. "@!!". `!`, `~`, `:`, `*` and `@` survive verbatim in browser address bars;
 *     `|` works too but browsers send it as %7C (vue-router decodes it back).
 *
 * Anything else (e.g. "favicon.ico") is treated as "no playlist" and the app falls back
 * to the public playlist, exactly as it always did for non-7-character paths.
 *
 * Keep in sync with utils/playlistID.js in the backend repo.
 */
export const PLAYLIST_ID_PATTERN = /^[A-Za-z0-9_\-~!@:*|]{2,32}$/;

export function isValidPlaylistID(id) {
  return typeof id === 'string' && PLAYLIST_ID_PATTERN.test(id);
}
